import React from "react";
import styled from "styled-components";
import { PanelLayout } from "@sonder/ui/source/styled/layouts/PanelLayout";
import { borders, colors, sizes } from "@sonder/ui/source/styled/theme";
import { useLoggedInUser } from "auth/hooks";
import { THIRTY_SECONDS } from "core/constants";
import { TaskPanel } from "tasks/components/TaskPanel";

const Layout = styled.div`
  box-shadow: ${colors.shadow};
  box-sizing: border-box;
  margin: 0rem auto;
  max-width: ${sizes.minBreakpoint};
  overflow: hidden;
  width: 100%;
  ${PanelLayout} > * {
    border-left: none;
  }

  @media screen and (min-width: ${sizes.minBreakpoint}) {
    border: ${borders.standard};
    border-radius: 0.3rem;
    margin: 1rem auto;
    max-width: ${sizes.sidepanelWidth};
  }
`;

export const StandaloneTaskView = () => {
  // Fetch user metadata and update auth stores
  useLoggedInUser();
  return (
    <Layout>
      <TaskPanel pollInterval={THIRTY_SECONDS} />
    </Layout>
  );
};
